// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const getAuthorizationQueryParamsSchema = z.object({
  client_id: z.optional(z.coerce.string().describe("OAuth 2.0 client identifier")),
  redirect_uri: z.optional(z.coerce.string().describe("OAuth 2.0 redirect URI")),
  response_type: z.optional(z.coerce.string().describe("OAuth 2.0 response type (must be \"code\")")),
  scope: z.optional(z.coerce.string().describe("OAuth 2.0 requested scope")),
  state: z.optional(z.coerce.string().describe("OAuth 2.0 state parameter")),
}).optional();

/**
 * @description authorization page
 */
export const getAuthorization200Schema = z.unknown();

/**
 * @description invalid request
 */
export const getAuthorization400Schema = z.unknown();

export const getAuthorizationQueryResponseSchema = z.lazy(() => getAuthorization200Schema);
